import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeInputComponent } from './code-input.component';

@NgModule({
  declarations: [CodeInputComponent],
  imports: [CommonModule],
  exports: [CodeInputComponent],
})
export class CodeInputModule {}
